/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-status-help': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm0 16.25a7.5 7.5 0 110-15 7.5 7.5 0 010 15zm0-1.875a.937.937 0 100-1.875.937.937 0 000 1.875zM10.625 5h-.938a2.806 2.806 0 00-2.812 2.813v.312h1.25v-.313c0-.862.7-1.562 1.563-1.562h.937a1.563 1.563 0 010 3.125h-1.25v2.813h1.25v-1.563a2.812 2.812 0 100-5.625z"/>'
  }
})
